export default "__VITE_ASSET__0xz2y27I__"